import { onMount } from 'solid-js';
import {
  customShadowlessElement,
  CorrectComponentType,
  correctElementType,
} from '@brytdesigns/web-component-core/utils';

type Props = { param: string };

const HydrateTabs: CorrectComponentType<Props> = (props, { element }) => {
  onMount(() => {
    const value = new URLSearchParams(window.location.search).get(props.param);
    if (!value) return;
    element.querySelector('tab-items')?.setAttribute('active-tab', value);
  });
};

customShadowlessElement('hydrate-tabs', { param: 'form' }, correctElementType(HydrateTabs));
